// extracted by mini-css-extract-plugin
module.exports = {"tabsList":"TabsList_tabsList__38ZpN","tabItem":"TabsList_tabItem__10yg9"};